export const getDivisions = (state: any) => {
  try {
    if (state && state.division && Array.isArray(state.division.divisions)) {
      return state.division.divisions;
    }
    if (state && state.divisions && Array.isArray(state.divisions.divisions)) {
      return state.divisions.divisions;
    }
    if (state && state.referenceData && Array.isArray(state.referenceData.divisions)) {
      return state.referenceData.divisions;
    }
    if (state && typeof state === "object") {
      for (const key of Object.keys(state)) {
        const slice = (state as any)[key];
        if (slice && Array.isArray(slice.divisions)) return slice.divisions;
      }
    }
  } catch (_) {
  }
  return [];
};
